import React, { useMemo } from 'react';
import { useActionItems } from './actionItems';
import NavDropdown from './NavDropdown';
import { useNavItems } from './navItems';
import type { NavItem } from './types';

type Props = {
  isAdminPage: boolean;
};

const isItemShown = (item: NavItem) => item.shown !== false;

const useHamburgerMobileNavItems = (): NavItem[] => {
  const navItems = useNavItems();

  return useMemo(() => {
    return [
      navItems.taxDashboard,
      navItems.holdings,
      navItems.incomeDashboard,
      navItems.documents,
      navItems.allTransactions,
      navItems.imports,
      navItems.profile,
      navItems.recon,
      navItems.upgrade,
      navItems.accountSettings,
    ].filter(isItemShown);
  }, [navItems]);
};

const useAdminHamburgerMobileNavItems = (): NavItem[] => {
  const navItems = useNavItems();

  return useMemo(
    () => [navItems.admin, navItems.csvsInReview, navItems.apiErrors, navItems.scripts, navItems.trello],
    [navItems],
  );
};

export default function MobileDropdown({ isAdminPage }: Props) {
  const actionItems = useActionItems({ isAdminPage });
  const hamburgerMobileNavItems = useHamburgerMobileNavItems();
  const adminHamburgerMobileNavItems = useAdminHamburgerMobileNavItems();

  return (
    <NavDropdown
      items={[...(isAdminPage ? adminHamburgerMobileNavItems : hamburgerMobileNavItems), ...actionItems]}
      dropdownBody={
        <button className="flex items-center cursor-pointer leading-3">
          <span className="text-white material-icons text-[32px] ml-1">menu</span>
        </button>
      }
    />
  );
}
